<script>
import { mapActions, mapGetters } from "vuex";
// import store from "@/state/store";
import moment from "moment";
import {
  required,
  //   between,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";

import Api from "../../../services/integrationApi";
import CustomStore from "devextreme/data/custom_store";

import PageHeader from "@/components/page-header";
// import DataTable from "@/components/grid/DataTable";
// import EditIntegModal from "@/components/integration/EditIntegrationModal";
import SyncIntegModal from "@/components/integration/SyncIntegrationModal";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import { default as Button } from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import "whatwg-fetch";
const dataGridRef = "dataGrid";
import DxDataGrid, {
  DxColumn,
  // DxLookup,
  DxFilterRow,
  DxHeaderFilter,
  // DxSearchPanel,
  DxColumnChooser,
  DxPaging,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  // DxGrouping,
  // DxGroupPanel,
} from "devextreme-vue/data-grid";
function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}
export default {
  components: {
    Breadcrumb,
    PageHeader,
    // EditIntegModal,
    // DataTable,
    SyncIntegModal,
    DxDataGrid,
    DxColumn,
    // DxLookup,
    DxFilterRow,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    // DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxToolbar,
    DxItem,
    DxDropDownButton,
    Button,
    DxScrolling,
  },
  data() {
    return {
      rtlEnabled: false,
      allFilterHeaders: ["user_type"],
      showClearAll: false,
      multipleFilters: [],
      userTypeHeaderFilter: [],
      totalCount: 0,
      sortObject: 0,
      finalFilterObject: 0,
      dataStore: new CustomStore({
        key: "id",
        load: (loadOptions) => {
          console.log("load fn from custom store fired");
          let params = "?";
          let filterQuery = "";
          console.log("filterQuery", filterQuery);
          let sortObject = { sortField: null, sortOrder: "" };
          [
            "skip",
            "take",
            "requireTotalCount",
            "requireGroupCount",
            "sort",
            "filter",
            "totalSummary",
            "group",
            "groupSummary",
          ].forEach((i) => {
            console.log("forEach", i, loadOptions[i]);
            console.log("isnotempty", isNotEmpty(loadOptions[i]));
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
              params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              if (i == "filter") {
                console.log("loadOptions[i]", loadOptions[i]);
                filterQuery += `${JSON.stringify(loadOptions[i])}`;
              }
              if (i == "sort") {
                sortObject.sortField = loadOptions[i][0].selector;
                sortObject.sortOrder = loadOptions[i][0].desc ? "desc" : "asc";
              }
            }
          });
          // this.resetUsersData();
          console.log("1 params", params);
          params = params.slice(0, -1);
          console.log("2 params", params);
          let filters;
          let finalFilterObject = {};
          this.multipleFilters = [];
          if (filterQuery) filters = JSON.parse(filterQuery);
          if (filters) console.log("filters", filters);
          if (filters && typeof filters[0] === "string") {
            if (filters[0] == "!") {
              console.log("not");
              if (typeof filters[1] === "object") {
                const excludeIds = [];
                const columnHeader =
                  typeof filters[1][0] === "object"
                    ? filters[1][0][0] + "HeaderFilter"
                    : filters[1][0] + "HeaderFilter";
                const columnHeaderFilter =
                  columnHeader.charAt(0).toLowerCase() + columnHeader.slice(1);
                if (typeof filters[1][0] === "object") {
                  filters[1].map((item) => {
                    if (typeof item === "object") {
                      excludeIds.push(item[2][0]);
                    }
                  });
                } else {
                  console.log("else");
                  // filters[1].map(item => {
                  // if (typeof item === "object") {
                  console.log("item", filters[1][2][0]);
                  excludeIds.push(filters[1][2][0]);
                  // }
                  // });
                }
                console.log(this[columnHeaderFilter]);
                const arr = this[columnHeaderFilter].filter(
                  (el) => !excludeIds.includes(el.value[2][0])
                );
                console.log("arr", arr, excludeIds);
                if (typeof filters[1][0] === "object") {
                  finalFilterObject[filters[1][0][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                } else {
                  finalFilterObject[filters[1][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                }
                if (this.multipleFilters.length > 0) {
                  this.multipleFilters.push(finalFilterObject);
                }
              }
            } else {
              if (
                (filters[1] === "contains" || filters[1] === "=") &&
                this.allFilterHeaders.includes(filters[0])
              )
                filters[2] = [filters[2]]; // make it array;
              finalFilterObject[filters[0]] =
                filters[1] === "contains" || filters[1] === "="
                  ? filters[2]
                  : filters[2];
            }
            if (this.multipleFilters.length > 0) {
              this.multipleFilters.push(finalFilterObject);
            }
          } else {
            // const isOr = filters[1] === 'or';
            // const isAnd = filters[1] === 'and';
            if (filters)
              for (const filter of filters) {
                if (filter[0] == "!") {
                  // console.log('multiple filters not');
                  if (typeof filter[1] === "object") {
                    const excludeIds = [];
                    const columnHeader =
                      typeof filter[1][0] === "object"
                        ? filter[1][0][0] + "HeaderFilter"
                        : filter[1][0] + "HeaderFilter";
                    const columnHeaderFilter =
                      columnHeader.charAt(0).toLowerCase() +
                      columnHeader.slice(1);
                    // console.log(columnHeader); // name of column filter
                    if (typeof filter[1][0] === "object") {
                      // console.log('obj');
                      filter[1].map((item) => {
                        if (typeof item === "object") {
                          // console.log('item', item[2][0]);
                          excludeIds.push(item[2][0]);
                        }
                      });
                    } else {
                      // console.log('else');
                      // filters[1].map(item => {
                      // if (typeof item === "object") {
                      // console.log('item', filter[1][2][0]);
                      excludeIds.push(filter[1][2][0]);
                      // }
                      // });
                    }
                    // console.log(this[columnHeaderFilter]);
                    const arr = this[columnHeaderFilter].filter(
                      (el) => !excludeIds.includes(el.value[2][0])
                    );
                    // console.log('arr', arr, excludeIds);
                    if (typeof filter[1][0] === "object") {
                      finalFilterObject[filter[1][0][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    } else {
                      finalFilterObject[filter[1][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    }
                    // console.log('finalFilterObject', finalFilterObject);
                    if (this.multipleFilters.length > 0) {
                      this.multipleFilters.push(finalFilterObject);
                    }
                  }
                }
                let orExist;
                let andExist;
                if (typeof filter === "object") {
                  // console.log('obj', filter);
                  orExist = filter.find((item) => item === "or");
                  andExist = filter.find((item) => item === "and");
                  if (filter[1] == "or") {
                    // Header Filter - Gather In One Condition
                    if (
                      filter[0][1] === ">=" ||
                      filter[0][1] === "<=" ||
                      filter[0][1] === "<"
                    ) {
                      const finalFilter = {};
                      const condition = [];
                      for (const filterItem of filter) {
                        if (filterItem[2]) condition.push(filterItem[2][0]);
                      }
                      finalFilter[filter[0][0]] = {
                        start: condition[0].replace(/\//g, "-"),
                        end: condition[1].replace(/\//g, "-"),
                      };
                      this.multipleFilters.push(finalFilter);
                    } else {
                      // Gather In One Condition
                      for (const filter of filter) {
                        if (filter[1] === "contains" || filter[1] === "=") {
                          if (this.allFilterHeaders.includes(filter[0]))
                            filter[2] = [filter[2]]; // make it array;
                          const finalFilter = {};
                          finalFilter[filter[0]] =
                            filter[1] === "contains" || filter[1] === "="
                              ? filter[2]
                              : filter[2];

                          // Header Filter - Gather In One Condition
                          const filterExist = this.multipleFilters.find(
                            (item) => item[filter[0]]
                          );
                          if (!filterExist)
                            this.multipleFilters.push(finalFilter);
                          else filterExist[filter[0]].push(filter[2][0]);
                        }
                      }
                    }
                  } // -------------- Header Filter --------------------
                  if (
                    filter.length > 0 &&
                    filter[0] &&
                    filter[0] !== "Actions" &&
                    !orExist &&
                    !andExist
                  ) {
                    if (filter[1] === "contains" || filter[1] === "=") {
                      if (this.allFilterHeaders.includes(filter[0]))
                        filter[2] = [filter[2]]; // make it array;
                      const finalFilter = {};
                      finalFilter[filter[0]] =
                        filter[1] === "contains" || filter[1] === "="
                          ? filter[2]
                          : filter[2];

                      // Header Filter - Gather In One Condition
                      const filterExist = this.multipleFilters.find(
                        (item) => item[filter[0]]
                      );
                      if (!filterExist) this.multipleFilters.push(finalFilter);
                      else filterExist[filter[0]].push(filter[2][0]);
                    }
                  } else if (andExist) {
                    for (const andFilter of filter) {
                      if (
                        andFilter.length > 0 &&
                        andFilter[0] &&
                        andFilter[0] !== "Actions"
                      ) {
                        if (
                          andFilter[1] === "contains" ||
                          andFilter[1] === "="
                        ) {
                          if (this.allFilterHeaders.includes(andFilter[0]))
                            andFilter[2] = [andFilter[2]]; // make it array;
                          const finalFilter = {};
                          finalFilter[andFilter[0]] =
                            andFilter[1] === "contains" || andFilter[1] === "="
                              ? andFilter[2]
                              : andFilter[2];
                          this.multipleFilters.push(finalFilter);
                        }
                      }
                    }
                  }
                }
              }
          }

          finalFilterObject =
            this.multipleFilters && this.multipleFilters.length > 0
              ? Object.assign({}, ...this.multipleFilters)
              : finalFilterObject;

          this.filterExportObject = finalFilterObject;
          this.sortExportObject = sortObject;

          console.log(
            "fffff",
            finalFilterObject,
            JSON.stringify(finalFilterObject)
          );

          let queryParams = {
            filterBy: finalFilterObject,
            orderBy: sortObject ? sortObject : { sortField: null },
          };

          if (this.isExport) {
            queryParams.isExporting = true;
          }
          return Api()
            .get(
              `/integration/${this.getIntegId}/${
                this.getFromView ? "users" : "tempUsers"
              }/${this.getFromView ? "synced" : "valid"}/${
                this.userDetails.id
              }${
                this.getFromView ? "" : `/${this.currentEntity.owner_id}`
              }${params}`,
              {
                params: queryParams,
              }
            )
            .then((data) => {
              const dataArr = [];
              console.log("weeee", data);
              data.data.map((user) => {
                dataArr.push({
                  dir_int_id: user.dir_int_id,
                  email: user.email,
                  first_name: user.first_name,
                  last_name: user.last_name,
                  phone: user.phone,
                  id: user.id,
                  rfid_number: user.rfid_number,
                  user_id: user.user_id,
                  user_type:
                    user && user.user_type
                      ? user.user_type && user.user_type.name
                        ? user.user_type.name
                        : Object.values(JSON.parse(user.user_type))[0]
                      : "-",
                  last_sync: user.last_sync,
                  is_dir_deleted: user.is_dir_deleted,
                  is_dir_deactivated: user.is_dir_deactivated,
                });
              });

              // this.isServerSideExport = data.data.totalCount >= process.env.VUE_APP_EXPORT_LIST_COUNT;
              this.finalFilterObject = finalFilterObject;
              this.sortObject = sortObject ? sortObject : { sortField: null };
              this.totalCount = data.data.totalCount;
              return {
                data: dataArr,
                totalCount: data.totalCount,
                summary: data.summary,
                groupCount: data.data.length,
              };
            })
            .catch((err) => {
              throw new Error(err);
            });
        },
        // eslint-disable-next-line no-unused-vars
      }),
      buttonData: ["Excel", "CSV", "PDF"],
      dataGridRef,
      title: "Integrations",
      usersCount: null,
      isLoading: true,
      update: true,
      submitted: false,
      userPhone: null,
      currentPhone: false,
      userCountryCode: null,
      form: {
        user: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          image: null,
          user_type_id: null,
          rfid_number: null,
          user_user_id: null,
          //   system_user: false,
          department_id: null,
          role_id: null,
        },
        entity: {
          entity_id: null,
        },
      },
      items: [
        {
          text: this.$t("sideNavbarMenu.integration.text"),
          to: { name: "addIntegration" },
        },
      ],
    };
  },

  validations: {
    form: {
      user: {
        first_name: { required },
        last_name: { required },
        email: {
          required: requiredIf(function () {
            const {
              form: {
                user: { phone },
              },
            } = this;
            return !phone;
          }),
        },
        phone: {},
        user_type_id: { required },
        user_user_id: { required },
      },
    },
    userPhone: {
      required: requiredIf(function () {
        const {
          form: {
            user: { email, phone },
          },
        } = this;
        return !email && !phone;
      }),
      numeric,
    },
  },

  methods: {
    ...mapActions("dailyLogbook", ["fetchUserTypes"]),
    ...mapActions("integration", [
      "fetchValidTempUsers",
      "fetchSyncedUsers",
      // "fixTempUsersWithErrors",
      "redirectType",
      "redirectToIntegrationSettings",
    ]),
    ...mapActions("modal", ["onResetModal", "setData"]),
    // ...mapActions("users", ["updateUserAction"]),

    ...mapActions("integration", ["StartSyncUsers"]),

    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    onItemClick(e) {
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "All Users.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "All Users.csv"
            );
          });
        });
      } else if (e.itemData == "PDF") {
        const doc = new jsPDF("landscape");
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: this.dataGrid,
        }).then(() => {
          doc.save("All Users.pdf");
        });
      }
    },

    clearFilter() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },

    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },

    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },

    setColumnChooserPosition() {
      // this.dataGrid.showColumnChooser();
      // console.log("columnChooserView");

      var columnChooserView = this.dataGrid.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.rtlEnabled ? "right top" : "left top",
        at: this.rtlEnabled ? "right top" : "left top",
        offset: "0 50",
      });
    },

    setResetModal() {
      this.$bvModal.hide("add-edit-user");
    },

    hideModalTrigger() {
      this.setData(null);
    },

    openEditUserModal(data) {
      //   this.setData({});
      console.log("modal", data);
      this.form.user = data;
      this.form.user.user_type_id = {
        id: Object.keys(data.user_type)[0],
        name: Object.values(data.user_type)[0],
      };
      //   this.form.user.first_name = data.firstName;
      //   this.form.user.last_name = data.lastName;
      //   this.form.user.email = data.emailAddress;
      //   this.form.user.phone = data.phoneNumber;
      this.form.user.user_user_id = data.id;
      //   this.form.user.rfid_number = data.RFID;
      //   console.log(this.form.user);
      this.currentPhone = data.phone ? true : false;
    },

    generateUserID() {
      let length = 8,
        charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      let i = 0,
        n = charset.length;
      for (; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.form.user.user_user_id = "VP-" + retVal;
    },

    calculateStatus(rowData) {
      if (rowData.is_dir_deleted)
        return (
          "Deleted " +
          moment(new Date(rowData.last_sync + " UTC")).format(
            "DD-MM-YYYY, h:mm:ss A"
          )
        );
      if (rowData.is_dir_deactivated)
        return (
          "Deactivated " +
          moment(new Date(rowData.last_sync + " UTC")).format(
            "DD-MM-YYYY, h:mm:ss A"
          )
        );
      return (
        "Synced " +
        (rowData.last_sync
          ? moment(new Date(rowData.last_sync + " UTC")).format(
              "DD-MM-YYYY, h:mm:ss A"
            )
          : "-")
      );
    },
    // onSubmit() {
    //   this.submitted = true;
    //   this.$v.$touch();
    //   this.$v.$error ? "" : this.submission();
    // },

    // submission() {
    //   // const { fixTempUsersWithErrors } = this;
    //   // const data = this.form.user;
    //   // data.phone =
    //   //   this.form.user.phone = `${this.userCountryCode}${this.userPhone}`;
    //   // data.user_type = JSON.stringify(this.form.user.user_type);
    //   console.log("sync");
    //   this.StartSyncUsers({id: this.getIntegId, isFailed: false });
    //   // console.log("count", this.getUsersWithErrsCount);
    // },

    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
    },

    onChangeToUpdatePhone() {
      this.currentPhone = false;
    },

    redirectUser() {
      this.redirectType({ id: this.getIntegId });
    },

    redirectUserToIntegrationSettings() {
      this.redirectToIntegrationSettings();
    },
  },

  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("dailyLogbook", ["getUserTypes"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("authfack", ["userDetails"]),
    ...mapGetters("integration", [
      "getLoading",
      "getModalState",
      "getSyncStatusStage",
      "getSyncStatusText",
      "getSyncStatusmsg",
      "getValidUsers",
      "getValidUsersCount",
      "getSyncedUsers",
      "getSyncedUsersCount",
      //    "getMigrateStatusText",
      //   "getMigrateStatusStage",
      //   "getMigrateStatusmsg",
      "getIntegId",
      "getIntgDataMapping",
      "getUsersWithErrs",
      "getUsersWithErrsCount",
      "getFromView",
    ]),
    // ...mapGetters("userType", ["getAllUsersTypes"]),
    // ...mapGetters("users", ["getLoading"]),

    dataGrid() {
      return this.$refs[this.dataGridRef].instance;
    },
  },
  beforeMount() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.fetchUserTypes().then(data => {
      data.data.map((userType) => {
        this.userTypeHeaderFilter.push({
          text: userType.name,
          value: ["user_type", "contains", [userType.id]],
        });
      });
    });
  },
  async mounted() {
    if (this.getFromView) {
      await this.fetchSyncedUsers(this.getIntegId).then((res) => {
        this.usersCount = res.totalCount;
      });
    } else {
      await this.fetchValidTempUsers(this.getIntegId).then((res) => {
        this.usersCount = res.totalCount;
      });
    }
    console.log(this.getFromView);

    // this.getIntegId = 80;
    console.log("mounted", this.getIntegId, this.usersCount);
    this.items.push(
      {
        text: this.getIntgDataMapping ? this.getIntgDataMapping.name : "",
        to: {
          name: "viewIntegration",
          params: {
            integId: this.getIntegId,
            integName: this.getIntgDataMapping
              ? this.getIntgDataMapping.name
              : "",
          },
        },

        // active: true,
      },
      {
        text: this.$t("integrations.syncedList"),
        // to: { name: "viewIntegration" },
        active: true,
      }
    );
  },

  watch: {
    getModalState(state) {
      state == true && this.$bvModal.hide("add-edit-user");
    },
  },

  created() {
    console.log("rowsData", this.rowsData);
    // document.addEventListener("mousedown", (e) => {
    //   if (e.path) {
    //     // console.log("path", e.path);
    //     let isColumnChooser = false;
    //     for (let i = 0; i < e.path.length; i++) {
    //       if (typeof e.path[i].matches == "function") {
    //         if (e.path[i].matches(".dx-overlay-content")) {
    //           isColumnChooser = true;
    //         }
    //       }
    //     }
    //     if (!isColumnChooser) this.dataGrid.hideColumnChooser();
    //   }
    // });
  },
};
</script>

<template>
  <div>
    <b-modal
      id="syncIntegrationConfirmModal"
      scrollable
      hide-footer
      hide-header
      size="lg"
    >
      <SyncIntegModal />
    </b-modal>

    <VpFormLayout>
      <template v-slot:content-header>
        <Breadcrumb
          v-if="getFromView"
          style="background-color: transparent"
          :items="items"
        />
        <PageHeader v-else :title="title" />
      </template>
      <template v-slot:content-body>
        <!-- grid -->
        <section class="white-bg-sec dashboard-grid">
          <div class="header-content">
            <div class="d-flex error-count" style="margin-bottom: 17px">
              <h5 v-if="getFromView">{{ $t("integrations.syncedList") }}</h5>
              <h5 v-else>{{ $t("integrations.allRecords") }}</h5>
              <span>{{ usersCount }}</span>
            </div>
            <p class="note" v-if="getFromView">
              {{ $t("integrations.syncNote") }}
            </p>
            <p class="note" v-else>
              {{ $t("integrations.syncNote2") }}
              <b>“{{ $t("integrations.sync") }}”</b>
              {{ $t("integrations.toConfirm") }}
            </p>
          </div>
          <DxDataGrid
            v-if="!getLoading"
            id="rec-gridContainer"
            :ref="dataGridRef"
            :data-source="dataStore"
            :remote-operations="true"
            :rtl-enabled="rtlEnabled"
            :showBorders="false"
            :columnAutoWidth="true"
            :allowColumnReordering="true"
            :allowColumnResizing="true"
            :rowAlternationEnabled="false"
            :showColumnLines="true"
            :showRowLines="true"
            :repaint-changes-only="true"
            :two-way-binding-enabled="true"
            :no-data-text="
              getFromView
                ? usersCount
                  ? 'No data'
                  : ''
                : getValidUsersCount
                ? 'No data'
                : ''
            "
            @content-ready="contentReady($event)"
            @editor-preparing="onEditorPreparing($event)"
          >
            <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
            <DxPaging :page-size="10" />
            <DxPager
              :visible="true"
              :allowed-page-sizes="[5, 10, 25, 50, 100, 'all']"
              :display-mode="'full'"
              :show-page-size-selector="true"
              :show-info="true"
              :show-navigation-buttons="true"
              :infoText="$t('common.page')"
            />

            <DxFilterRow :visible="true" />
            <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter"/> -->

            <DxHeaderFilter :visible="true" />

            <!-- <DxSearchPanel :visible="true" placeholder="Search..." /> -->

            <DxColumnChooser
              :enabled="true"
              mode="select"
              :title="$t('common.grid.columnChooser')"
            />

            <!-- <DxGrouping :context-menu-enabled="true"/>
          <DxGroupPanel :visible="true"/> -->

            <DxExport :enabled="true" :allow-export-selected-data="false" />

            <DxToolbar>
              <!-- <DxItem name="columnChooserButton" location="before" /> -->
              <DxItem location="before" template="columnButtonTemplate" />
              <DxItem template="exportButtonTemplate" location="before" />
              <DxItem template="clearAllTemplate" location="before" />
            </DxToolbar>

            <DxColumn
              data-field="first_name"
              :caption="$t('common.firstName')"
              :allow-header-filtering="false"
            />

            <DxColumn
              data-field="last_name"
              :caption="$t('common.lastName')"
              :allow-header-filtering="false"
            />

            <DxColumn
              data-field="email"
              :caption="$t('common.emailAddress')"
              :allow-header-filtering="false"
            />

            <DxColumn
              data-field="phone"
              :caption="$t('common.phoneNumber')"
              :allow-header-filtering="false"
            />

            <DxColumn
              data-field="user_id"
              :caption="$t('common.id')"
              :allow-header-filtering="false"
            />

            <DxColumn
              data-field="rfid_number"
              :caption="$t('common.RFID')"
              :allow-header-filtering="false"
            />

            <DxColumn
              data-field="user_type"
              :caption="$t('common.userType')"
              :allow-filtering="false"
              :allow-header-filtering="true"
            >
              <DxHeaderFilter :data-source="userTypeHeaderFilter" />
            </DxColumn>

            <DxColumn
              :caption="$t('common.status')"
              :calculate-cell-value="calculateStatus"
              :allow-sorting="false"
              cell-template="status-cell"
              :visible="getFromView"
              :allow-filtering="false"
            />

            <template #clearAllTemplate>
              <div
                v-if="showClearAll"
                class="clear-cols d-flex align-items-center"
              >
                <div class="toolbar-custom-line"></div>
                <Button
                  :text="$t('common.grid.clearFilters')"
                  @click="clearFilter"
                  styling-mode="outlined"
                  type="danger"
                  class="clear-CustomColums"
                />
              </div>
            </template>

            <template #exportButtonTemplate>
              <DxDropDownButton
                class="export-dropdown"
                :items="buttonData"
                :text="$t('common.grid.export')"
                @item-click="onItemClick"
              />
            </template>

            <template #columnButtonTemplate>
              <button
                class="custom-columns"
                @click="dataGrid.showColumnChooser()"
              >
                <span class="custom-text"
                  >{{ $t("common.grid.columns") }}
                </span>

                <span class="custom-icon">
                  <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
                </span>
              </button>
            </template>

            <template #status-cell="{ data }">
              <div
                :class="{
                  'text-success':
                    !data.data.is_dir_deleted && !data.data.is_dir_deactivated,
                  'text-danger':
                    data.data.is_dir_deleted || data.data.is_dir_deactivated,
                }"
              >
                {{ data.value }}
              </div>
            </template>
          </DxDataGrid>

          <div class="action-btns" v-if="!getFromView">
            <button
              class="submit-btn btn btn-primary"
              size="md"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 40px !important;
                margin-top: 20px !important;
              "
              @click="redirectUserToIntegrationSettings"
            >
              <span class="back-style">{{ $t("common.back") }}</span>
            </button>
            <button
              class="submit-btn btn btn-primary"
              size="md"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 40px !important;
                margin-top: 20px !important;
              "
              v-b-modal="'syncIntegrationConfirmModal'"
              :disabled="getLoading"
            >
              <i
                v-if="getLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span class="back-style">{{ $t("integrations.sync") }}</span>
            </button>
          </div>
        </section>
      </template>
    </VpFormLayout>
  </div>
</template>

<style lang="scss" scoped>
span.back-style {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
}
.custom-columns {
  margin-inline-start: -11px !important;
}

.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-end: 15px;
  border-right-color: #d9d9d9;
}
.white-bg-sec {
  background-color: white;
  padding-inline-start: 36px;
  // padding-top: 32px;
}
.error-count {
  padding-inline-start: 4px;
  h5 {
    font-weight: 900;
    font-size: 20px;
    line-height: 24px;
    color: #939393;
    opacity: 0.46;
  }
  span {
    width: 47px;
    height: 29px;
    text-align: center;
    background: #103f5e;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    border-radius: 15.5px;
    margin-inline-start: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.header-content {
  width: 100%;
  background: white;
  padding-bottom: 1px;
  padding-top: 40px;
}
.note {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
  padding-inline-start: 4px;
  margin-bottom: 28px;
}
</style>
<style lang="scss">
div#rec-gridContainer {
  .dx-datagrid-header-panel {
    padding-inline-start: 12px !important ;
  }
}

.dashboard-grid {
  border-start-start-radius: 6px !important;
  tbody {
    color: #495057;
  }
}
</style>
